export class PayeeFormClass {
    async getAvailablePayees() {
        throw new Error("get available payees in PayeeForm class needs to be overwritten");
    }
}